export default "__VITE_ASSET__CjH1lI7V__"